import { render, staticRenderFns } from "./ShippingCostMain.vue?vue&type=template&id=7f3653b8"
import script from "./ShippingCostMain.vue?vue&type=script&lang=js"
export * from "./ShippingCostMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f3653b8')) {
      api.createRecord('7f3653b8', component.options)
    } else {
      api.reload('7f3653b8', component.options)
    }
    module.hot.accept("./ShippingCostMain.vue?vue&type=template&id=7f3653b8", function () {
      api.rerender('7f3653b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/schedule/ShippingCostMain.vue"
export default component.exports